import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import _ from "lodash";
import { useMenu } from "../../../store/global/useMenu";

const LinkContext = createContext({});

function LinkProvider({ children, name, to }) {
  const { pathname } = useLocation();

  const submenu = _.isArray(to);
  const active = submenu ? _.some(to, ['to', pathname]) : to === pathname

  useMenu.getState().actions.setItem({ name, submenu, active, open: active });

  useEffect(() => {
    if (active) useMenu.getState().actions.setActive(name);
  }, [pathname, active])

  return (
    <LinkContext.Provider value={{ name }}>
      {children}
    </LinkContext.Provider>
  );
}

function useLinkContext() {
  const context = useContext(LinkContext);
  if (!context) throw new Error("use must be used within an Provider");

  return context;
}

export { useLinkContext, LinkProvider };
